module.exports = __webpack_public_path__ + "static/media/calendar.7372dd26.svg";